import React, {Component} from "react";
import {connect} from 'react-redux';
import {Grid} from "@mui/material";
import AnnotationsExpandableList from "./AnnotationsExpandableList";
import {locateAnnotationOnMap} from "../utils/map_utils";
import {AnnotationsConstants, Loader} from "../../../utils/const";
import {LoadingText} from "../components/components";
import {annotationsApp, tileViewApp} from "../app_maker";

class AnnotationsApp extends Component {

    emptyComponent = () => <Grid>
        No Annotations Drawn
    </Grid>;

    render() {
        if (this.props.loadingState.loading) {
            return <Loader/>
        }
        if (!this.props.annotationState)
            return <LoadingText/>;

        if (!(this.props.annotationState || {}).annotations) return this.emptyComponent();

        let annotations = this.props.annotationState.annotations
            .filter(annotation => this.props.tileMapEnable ? annotation.anno_drawer === tileViewApp.drawer :
                annotation.anno_drawer === annotationsApp.drawer)

        annotations.forEach(annotation => {
            annotation.checked = this.props.annotationState.selectedAnnotations
                && this.props.annotationState.selectedAnnotations.includes(annotation.id)
        });

        if (annotations.length === 0)
            return this.emptyComponent();

        return <AnnotationsExpandableList annotations={annotations}
                                          slideId={this.props.slide.id}
                                          showMergeAnnotations={true}
                                          onAnnotationClick={(annotation) =>
                                              locateAnnotationOnMap(this.props.slidemap, annotation, false)}
                                          colors={AnnotationsConstants.ANNO_COLORS}
                                          deselectPostAction={true}
                                          showDownload={true}/>
    }
}

const mapStateToProps = (state) => {
    let loadingState = state.slideLoadingReducer;
    let {activeMapId, tileMapEnable} = state.gammaStateReducer;
    let {slide, slidemap, annotationState} = state.mapsStateReducer[activeMapId] ?? {};

    return {slide, slidemap, tileMapEnable, annotationState, loadingState};
}

export default connect(mapStateToProps)(AnnotationsApp)